/**
 * Function to post messages to a parent iframe from the iframe content
 * @param {object|string} payload serialisable message
 */
export default function sendMessageToParentIframe(payload) {
    window.parentIFrame?.sendMessage(payload);
}
